export default {
  namespaced: true,
  state: {
    toDoCountState: false,


  },
  getters: {



  },
  mutations: {
    SET_TODO_COUNT_STATE(state, value) {
      state.toDoCountState = value
    },
  },
  actions: {},
}
